module.exports = __webpack_public_path__ + "img/4e06900.png";